export default __webpack_public_path__ + "static/media/job_offer2_m.ac491b40.jpg";